import axios from 'axios'

export default axios.create({
    baseURL: 'http://43.136.120.154:9033',
    timeout: 10000
})


// WEBPACK FOOTER //
// ./src/api/index.js